module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back"
  }, [_c('van-tabs', {
    staticClass: "tab-nav",
    attrs: {
      "sticky": ""
    },
    on: {
      "click": _vm.onStatusChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "正常"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "隐藏"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box yundongyuan-box"
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('div', {
    staticClass: "kaojicenter-list-box"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "kaojicenter-lists flex-between",
      on: {
        "click": function($event) {
          return _vm.action(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "kaojicenter-rights"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "desc flex-start"
    }, [(item.cert_status == 1) ? _c('van-tag', {
      attrs: {
        "round": "",
        "type": "success"
      }
    }, [_vm._v("已认证")]) : (item.cert_status == 3) ? _c('van-tag', {
      attrs: {
        "round": ""
      }
    }, [_vm._v("认证失败")]) : (item.cardtype == 1 && item.cert_status == 2) ? _c('van-tag', {
      attrs: {
        "round": "",
        "type": "warning"
      }
    }, [_vm._v("未认证")]) : (item.cardtype != 1 && item.cert_status == 2) ? _c('van-tag', {
      attrs: {
        "round": "",
        "plain": ""
      }
    }, [_vm._v("无需认证")]) : _vm._e(), _vm._v("  \n                " + _vm._s(item.num) + "\n              ")], 1)])])
  }), 0)])], 1), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.actions
    },
    on: {
      "select": _vm.onActionSelect
    },
    model: {
      value: (_vm.actionShow),
      callback: function($$v) {
        _vm.actionShow = $$v
      },
      expression: "actionShow"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-uploader', {
    attrs: {
      "accept": ".xls,.xlsx",
      "after-read": _vm.readFile
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("导入模板\n        ")])], 1)], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.showLoading),
      callback: function($$v) {
        _vm.showLoading = $$v
      },
      expression: "showLoading"
    }
  }, [_c('div', {
    staticClass: "circle-div"
  }, [_c('van-circle', {
    attrs: {
      "stroke-width": 60,
      "color": {
        '0%': '#ffad19',
        '100%': '#fec835',
      },
      "rate": _vm.progress,
      "speed": 100,
      "text": _vm.progress + '%'
    },
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin-top": "10px"
    },
    attrs: {
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("上传中\n        ")])], 1), _vm._v(" "), _c('div')]), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "批量导入错误信息"
    },
    model: {
      value: (_vm.showError),
      callback: function($$v) {
        _vm.showError = $$v
      },
      expression: "showError"
    }
  }, [_c('van-cell-group', _vm._l((_vm.errorMsg), function(item, index) {
    return _c('van-cell', {
      key: index,
      attrs: {
        "title": item
      }
    })
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05fa89e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/member/YundongyuanListShare.vue
// module id = 2181
// module chunks = 0